<content>
    <form [formGroup]="newEditForm" [ngClass]="{'show-error':showError}">
        <div class="info">{{'global.infoRequired' | translate}}</div>
        <div class="entry-3-modal">
            <label>{{'global.pais' | translate}} *</label>
            <app-filterable-list class="short-list" [itemsList]="paises" [selectedItem]="newEditForm.get('pais')" [placeHolder]="false"></app-filterable-list>
        </div>
        <div class="entry-3-modal">
            <label>{{'global.provincia' | translate}} *</label>
            <app-filterable-list class="short-list" [itemsList]="provincias" [selectedItem]="newEditForm.get('provincia')" [disabled]="disabled" [placeHolder]="false"></app-filterable-list>
        </div>
        <div class="entry-3-modal">
            <label>{{'global.municipio' | translate}} *</label>
            <input type="text" formControlName="des">
        </div>
        <div class="entry-3-modal">
            <label>{{'mantenimientoMunicipios.table.codigoPostal' | translate}}</label>
            <input type="text" formControlName="codigoPostal">
        </div>
        <div class="entry-3-modal">
            <label>{{'mantenimientoMunicipios.table.escala' | translate}}</label>
            <input type="text" formControlName="escala">
        </div>
    </form>
</content>
<footer class="button-bar-right">
    <button class="secondary" (click)="close()">{{'global.cancelar' | translate}}</button>
    <button (click)="save()">{{municipioId ? ('global.actualizar' | translate) : ('global.insertar' | translate)}}</button>
</footer>

<app-toast *ngIf="(showError || showApiError) && mensajes" [messages]="mensajes" (closed)="showError=$event;showApiError=$event"></app-toast>